import axios from "axios";

export function getTemplateBody(name, locale) {
  return axios.get("/api/services/app/Template/GetTemplateBody", { params: { name, locale } });
}
